import { useState } from "react";
import { AbstructVar } from "../../general/general-component/abstruct-component/AbstructVar";

export const VariableCreativeWorkEvaluation = () => {
    let { navigate } = AbstructVar();

    const [state, setState] = useState({
        notes: '',
        creative_work_id: '',
        creative_evaluation: {
            degree: 0,
            creative_evaluation_type_id: '',
        },
        open: false,
        openEdit: false,
        arr1: [],
        Load: false
    });

    const setStateCustom = (variableName, value) => {
        console.log(value);
        setState((prevState) => ({
            ...prevState,
            [variableName]: value,
        }));
    };

    const setLoad = (value) => {
        console.log(value);
        setState((prevState) => ({
            ...prevState,
            Load: value,
        }));
    };

    const setOpen = (value) => {
        console.log(value);
        setState((prevState) => ({
            ...prevState,
            open: value,
        }));
    };

    const setopenEdit = (value) => {
        console.log(value);
        setState((prevState) => ({
            ...prevState,
            openEdit: value,
        }));
    };

    const handleEdit = (event, arr) => {
        event.preventDefault();
        navigate(`/project-request/${arr.id}`, { state: { arr } });
    };

    return {
        ...state,
        state,
        setState,
        handleEdit,
        setOpen,
        setopenEdit,
        setStateCustom,
        setLoad,
    };
};
